import React from 'react';

import { Button, Flex, Text } from '@opendoor/bricks/core';
import { ThemedLite } from '@opendoor/bricks/theme/ODThemeLite';

import { ContextSheet, Modal } from 'platform/bricks/Modal';

import { useMobileDevice } from 'shared/helpers/hooks/useMobileDevice';

interface IModalContentProps {
  onClick: () => void;
}

const ModalContent: React.FC<IModalContentProps> = ({ onClick }) => {
  return (
    <ThemedLite theme="novo">
      <Flex flexDirection="column" height="100%" alignItems="flex-start" mx={6}>
        <Text size="150" fontWeight="medium" mt={-6}>
          Getting pre-approved with Lower
        </Text>
        <Text size="110" mt={6}>
          Once you’re pre-approved, return with your letter and re-enter your info to create your
          contract.
        </Text>
        <Button
          analyticsName="cake-buy-direct-lower-pre-approval-confirmation-button"
          aria-label="Go to lower"
          variant="primary"
          size="md"
          onClick={onClick}
          my={8}
          alignSelf="center"
        >
          Go to Lower
        </Button>
      </Flex>
    </ThemedLite>
  );
};

interface ILowerMortgageModalProps {
  isOpen: boolean;
  onClick: () => void;
  onClose: () => void;
}

/**
 * Lower Mortgage Modal
 * storybook-check-ignore
 */
export const LowerMortgageModal: React.FC<ILowerMortgageModalProps> = ({
  isOpen,
  onClick,
  onClose,
}) => {
  const { isMobile } = useMobileDevice();
  return isMobile ? (
    <ContextSheet
      analyticsName="cake-buy-direct-lower-pre-approval-confirmation-modal"
      hasPadding
      isOpen={isOpen}
      onRequestClose={onClose}
      title="Need pre-approval?"
    >
      <ModalContent onClick={onClick} />
    </ContextSheet>
  ) : (
    <Modal
      aria-label="Getting pre-approved with Lower"
      analyticsName="cake-buy-direct-lower-pre-approval-confirmation-modal"
      hasPadding
      isOpen={isOpen}
      onRequestClose={onClose}
      showClose
      width="350px"
    >
      <ModalContent onClick={onClick} />
    </Modal>
  );
};
